var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69648",
    "data-name": "Group 69648",
    transform: "translate(-38.715 -54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_7_41",
    "data-name": "Component 7 \\u2013 41",
    transform: "translate(38.715 54)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye",
    "data-name": "Icon awesome-eye",
    d: "M11.992,8.216A6.718,6.718,0,0,0,6.032,4.5,6.719,6.719,0,0,0,.073,8.216a.678.678,0,0,0,0,.611,6.718,6.718,0,0,0,5.959,3.716,6.719,6.719,0,0,0,5.959-3.716A.678.678,0,0,0,11.992,8.216ZM6.032,11.538A3.016,3.016,0,1,1,9.048,8.521,3.016,3.016,0,0,1,6.032,11.538Zm0-5.027a2,2,0,0,0-.53.079,1,1,0,0,1-1.4,1.4A2.006,2.006,0,1,0,6.032,6.511Z",
    transform: "translate(4.469 1.979)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.76cf38b2bb6b2c17e84c94c8d30c8b8a.svg";
export { ForwardRef as ReactComponent };